<template>
	<button
		@click="$emit('click')"
		class="relative z-1 cursor-pointer close-button"
		:class="filled ? 'rounded-4 filled' : 'simple'"
	>
		<Icon
			icon="close"
			radius="24px"
			:class="filled ? 'text-white' : ''"
			:stroke-width="filled ? 2 : 1"
		/>
	</button>
</template>

<script setup lang="ts">
	interface Props {
		filled?: boolean
	}

	defineEmits(['click'])
	defineProps<Props>()
</script>
<style scoped lang="scss">
	.close-button {
		transform: translate(-50%, 50%);
		&.simple {
			background-color: transparent;
		}
		&.filled {
			background: #33312e66;
		}
	}
</style>
